// extracted by mini-css-extract-plugin
export default {"clearAllButton":"styles-module__clearAllButton___ED7kN"};